import React,{useState} from 'react'
import {Container,Card,Row,Col,Button} from 'react-bootstrap'
import ControlsMap from '../../../Properties/PropertiesConfiguration'
import CollapsibleComponent from "../../../../ReusableComponents/CollapseCard/CollapseCard";
import styles from "../../../LeftNavigation/DesignerControls/BasicControls.module.css"
import ColorPicker from "../../../../ReusableComponents/ColorPicker/ColorPicker"
import ToggleBtn from "../../../../ReusableComponents/ToggleBtn/ToggleBtn"
import SvgDeleteIcon from "../../../../Icons/DeleteIcon"
import AddColumnIcon from "../../../../Icons/AddColumnIcon"
import SvgEditIcon from "../../../../Icons/EditIcon"
import SvgCardIcon from "../../../../Icons/CardIcon"
import SvgLinedIcon from "../../../../Icons/LinedIcon"
import SvgBoxIcon from "../../../../Icons/BoxIcon"
import SvgStripedIcon from "../../../../Icons/StripedIcon"
import SvgDeleteWhiteIcon from "../../../../Icons/DeleteWhiteIcon"
import SvgDownloadIcon from "../../../../Icons/DownloadIcon"
import SvgSaveIcon from "../../../../Icons/SaveIcon"
import TableBackdrop from '../TableProperties/TableBackdrop'
import { createUniqueId } from '../../IFormDesignerLogic';

const DataAdditionPopup=(props)=>{
   
    
    function handleCombo(comboId){
       var select = document.getElementById(comboId);
       var propertyName = select.getAttribute("name");
       var optionTag = select.options[select.selectedIndex];
       handleProperty(propertyName, optionTag.value);
    }
    function handleProperty(propertyName, propertyValue){
        
        props.selectedControl.style[propertyName] = propertyValue;
        props.applyChanges(props.formData); 
    }
   
   function handleButton(arg){//console.log(arg);
        props.setShowDataAdditionSection(arg);
   }
    var InputItems = [];
    // if(props.data && props.data.columnList){
    //     props.data.columnList.map((obj,index)=>{ //console.log(obj);
    //             if( obj.style && obj.style.ColumnType){
    //                 InputItems.push(prepareHtmlTag(obj));
    //             }
    //     })
    // }
    
    if(props.data && props.data.listviewframelayout && props.data.listviewframelayout.children && props.data.listviewframelayout.children[0].children){  
        props.data.listviewframelayout.children[0].children.map((obj,index)=>{
                if( obj.style && obj.elem_type){
                    InputItems.push(prepareHtmlTag(obj));
                }
    
        })  
    }
    function prepareHtmlTag(obj) {
            switch(obj.style.ColumnType.toLowerCase()){
                case "combo" : return (
                            <div className={styles.dataAdditionControlDiv}>
                    <p className={styles.dataAdditionControlColumnName}>{obj.style.ColumnName}</p>
                    <div>
                        <select className={styles.dataAdditionControl} name={obj.style.ColumnName} id={obj.id+obj.style.ColumnName} onChange={()=>handleCombo(obj.id+obj.style.ColumnName)}>
                        {/* {obj.children.map((optionTagData,optionCount)=>{
                            
                                return <option value={ControlsMap[key].children[optionCount].Value}></option>
                            
                        })} */}
                        </select>
                    </div>
                    </div>
                        )
                

                case "toggle" : return(
                <div className={styles.dataAdditionControlDiv}>
                        <p className={styles.dataAdditionControlColumnName} >{obj.style.ColumnName}</p>
                        <ToggleBtn toggleState={false} handleStyleChange={(value)=>handleProperty(obj.style.ColumnName, value)}/> 
                    </div>
                )

                case "textarea" : return(
                <div className={styles.dataAdditionControlDiv}>
                        <p className={styles.dataAdditionControlColumnName}>{obj.style.ColumnName}</p>
                        <div>
                        <textarea aria-label={obj.style.ColumnName} className={styles.dataAdditionControl}/>
                        </div>
                    </div>
                ) 
                case "textbox" : return(
                    <div className={styles.dataAdditionControlDiv}>
                            <p className={styles.dataAdditionControlColumnName}>{obj.style.ColumnName}</p>
                            <div>
                            <input aria-label={"Column Name"}type="textbox" className={styles.dataAdditionControl}/>
                            </div>
                    </div>
                ) 
                case "text" : return(
                    <div className={styles.dataAdditionControlDiv}>
                            <p className={styles.dataAdditionControlColumnName}>{obj.style.ColumnName}</p>
                            <div>
                            <input aria-label={"Column Name"} type="text" className={styles.dataAdditionControl}/>
                            </div>
                    </div>
                )
                case "checkbox" : return(
                    <div className={styles.dataAdditionControlDiv}>
                            <p className={styles.dataAdditionControlColumnName}>{obj.style.ColumnName}</p>
                            <div>
                            <input aria-label={"Control Value1"} type="checkbox" className={styles.dataAdditionControl2}/>
                            </div>
                        </div>
                )
                case "radio" : return(
                    <div className={styles.dataAdditionControlDiv}>
                            <p className={styles.dataAdditionControlColumnName}>{obj.style.ColumnName}</p>
                            <div>
                            <input aria-label={"Column Property"} type="radio" className={styles.dataAdditionControl2}/>
                            </div>
                    </div>
                )
                case "datepick" : return(
                    <div className={styles.dataAdditionControlDiv}>
                            <p className={styles.dataAdditionControlColumnName}>{obj.style.ColumnName}</p>
                            <div>
                            <input aria-label={"Column Property"} type="date" className={styles.dataAdditionControl}/>
                            </div>
                    </div>
                    )    
        }

    }
    const [col, setCol] = useState(4);
    function handleCol(id){
       var selectTag = document.getElementById(id);
       setCol(selectTag.options[selectTag.selectedIndex].value)
    }


return (
        <>
        
        <Card.Body className={styles.cardBody}>
            <div className={styles.dataAdditionParentDiv}>
            <div className={styles.dataAdditionSectionHeaderDiv}>
                    <div className={styles.dataAdditionSectionHeaderInnerDiv3}>Listview Data</div>
                    <div className={styles.dataAdditionSectionHeaderInnerDiv2}>COL
                        <select id="col-Selection" className={styles.dataAdditionSectionHeaderInnerDiv2Select} onChange={()=>handleCol("col-Selection")}>
                            <option></option>
                            <option value="1" selected={col === "1" ? true : false}>1</option>
                            <option value="2" selected={col === "2" ? true : false}>2</option>
                            <option value="3" selected={col === "3" ? true : false}>3</option>
                            <option value="4" selected={col === "4" ? true : false}>4</option>
                            <option value="6" selected={col === "6" ? true : false}>6</option>
                            <option value="12" selected={col === "12" ? true : false}>12</option>
                        </select>
                    </div>
                    <div className={styles.dataAdditionSectionHeaderInnerDiv3}>
                        {/* <Button className={styles.dataAdditionSectionHeaderInnerDiv3Button}> Add to table</Button> */}
                    </div>
                </div>
                <div className={styles.containerParentDiv}>
                <Container className={styles.rowContainer}>
                   <Row>
                    {
                        InputItems.map((item,index)=>{
                            return <Col xs={col}>{item}</Col>;
                        })   
                    }
                    </Row>
                </Container>
                </div>
                 <div className={styles.dataAdditionButtonDiv}>
                    <button className={styles.subFormSaveButton} onClick={()=>handleButton(false)}><span className={styles.spanSaveIconA} ></span>Save & Close</button>
                    <button className={styles.subFormDownloadButton} onClick={()=>handleButton(false)}><span className={styles.spanDownloadIconA} ></span>Save & Continue</button>
                </div>
            </div>
        </Card.Body>
        
            <div className={styles.dataAdditionButtonDiv2}>
                <button className={styles.cancelButton}  onClick={()=>handleButton(false)}><span className={styles.spanDownloadIconA}></span>Cancel</button>
                <button className={styles.subFormSaveButton} onClick={()=>handleButton(false)}><span className={styles.spanSaveIconA} ><SvgSaveIcon/></span>Save Changes</button>
            </div>
        
       
        
        
        </>
    )

}

export default DataAdditionPopup;